import React, { useEffect } from 'react';
import { config } from 'src/config/config';
import { navigationService, toastNotificationsService } from 'src/config/rootService';
import { CenteredSpinner } from 'src/shared/components/CenteredSpinner';

const EmailAddressConfirmed: React.FC = () => {
    useEffect(() => {
        toastNotificationsService.renderSuccessToast(config.messages.emailConfirmed);

        const mobileBrowserDetected = /Mobi|Android/i.test(navigator.userAgent);

        if (mobileBrowserDetected) {
            window.location.replace('modernhealth://');
        }

        navigationService.navigate('/login');
    }, []);

    return <CenteredSpinner />;
};

export default EmailAddressConfirmed;
